import React from 'react';
import PropTypes from 'prop-types';
import { Icon, TooltipWrapper } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './CropWaterUseHeader.css';


function CropWaterUseHeader({ isSplitViewEnabled }) {
  const splitViewStyle = isSplitViewEnabled ? styles.splitView : '';
  const tooltipPlacement = isSplitViewEnabled ? 'bottom' : 'right';
  return (
    <div data-test-id="cropWaterUse-panel-header">
      <div className={`${styles.header} ${splitViewStyle}`}>
        <p className={styles.headerText}>
          {getMessage('card.avgdailywateruse.avgdailywateruse')}
        </p>
        <TooltipWrapper
          className={styles.tooltipWrapper}
          content={[getMessage('card.avgdailywateruse.info')]}
          mode="secondary"
          placement={tooltipPlacement}
          testId="cropWaterUse-panel-header-tooltip-wrapper"
        >
          <div className={styles.tooltip}>
            <Icon
              glyph={Icon.set.INFO_CIRCLE}
              testId="cropWaterUse-panel-header-tooltip"
            />
          </div>
        </TooltipWrapper>
      </div>
    </div>
  );
}

CropWaterUseHeader.propTypes = {
  isSplitViewEnabled: PropTypes.bool,
};

export default CropWaterUseHeader;
